var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeepseekThink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE6\xB7\xB1\xE5\xBA\xA6\xE6\x80\x9D\xE8\x80\x83 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.63501 2.63471C4.11601 1.15271 7.72001 2.35471 10.683 5.3167C13.646 8.2807 14.848 11.8837 13.366 13.3657C11.884 14.8477 8.28101 13.6457 5.31701 10.6827C2.35401 7.7197 1.15301 4.11571 2.63501 2.63471ZM9.97601 6.0247C7.35301 3.40171 4.30001 2.3837 3.34201 3.3417C2.38401 4.29971 3.40201 7.35271 6.02501 9.9757C8.64801 12.5987 11.701 13.6157 12.659 12.6587C13.617 11.7007 12.599 8.64771 9.97601 6.0247Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.31695 5.31688C8.28095 2.35388 11.8839 1.15288 13.3659 2.63488C14.8479 4.11588 13.6459 7.71988 10.6829 10.6829C7.71995 13.6459 4.11595 14.8479 2.63495 13.3659C1.15295 11.8839 2.35495 8.27988 5.31695 5.31688ZM12.6589 3.34188C11.7009 2.38388 8.64795 3.40188 6.02495 6.02488C3.40195 8.64788 2.38395 11.6999 3.34195 12.6589C4.29995 13.6169 7.35295 12.5989 9.97595 9.97588C12.5989 7.35288 13.6159 4.29988 12.6589 3.34188Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.91602 8.00002C6.91602 8.28751 7.03022 8.56323 7.23351 8.76652C7.4368 8.96981 7.71252 9.08402 8.00002 9.08402C8.28751 9.08402 8.56323 8.96981 8.76652 8.76652C8.96981 8.56323 9.08402 8.28751 9.08402 8.00002C9.08402 7.71252 8.96981 7.4368 8.76652 7.23351C8.56323 7.03022 8.28751 6.91602 8.00002 6.91602C7.71252 6.91602 7.4368 7.03022 7.23351 7.23351C7.03022 7.4368 6.91602 7.71252 6.91602 8.00002Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeepseekThink);
export default __webpack_public_path__ + "static/media/deepseek_think.9b5802f482fdb22e3dd665caa72d98bf.svg";
export { ForwardRef as ReactComponent };